<template>

    <div class="user-story-task-outer" draggable="true" @dragstart="dragStart(item.id, $event)" @dragend="dragEnd($event)" >
        <div v-bind:class="{'user-story-task': item.id.includes('tk'), 'user-story-issue': item.id.includes('bg')}">
            <div class="task-body">
                <div class="assign">
                    <user-select :user="item.user" :userChanged="userChanged"></user-select>
                </div>

                <div class="right">
                    <span class="task-heading text-truncate text-upper" v-bind:class="{'text-danger': item.id.includes('bg')}">{{item.id}}</span>

                        <div class="dropdown d-inline-block float-end" >
                            <button type="button" v-dropdown class="btn btn-card-menu" aria-label="Actions"><i class="fal fa-ellipsis-v"></i></button>

                            <div class="dropdown-menu" v-on:click.stop>
                                <a class="dropdown-item" href="#" @click="onDeleteClick"><i class="fal fa-trash" style="margin-right:5px;"></i> Delete</a>
                            </div>
                        </div>

                    <div class="description">
                        <textarea style="width:100%;" ref="stateTitle" class="task-title-textarea form-control" v-if="edit" @blur="onTitleBlur" v-auto-height v-model="stateTitle" @keyup="markDirty" placeholder="Title"></textarea>
                        <div v-show="!edit" @click="onTitleClick" v-html="getFormattedTitle"></div>
                    </div>

                    <tag :value="stateTags" @input="handleSelectTagCallback" @tag="handleAddNewTag"></tag>
                </div>
            </div>

            <div class="task-footer">
                <div class="row g-0">
                    <div class="col">
                        <ul class="task-times">
                            <li title="Effort Logged (spent)"><span>S</span> {{item.time_entries_total | toHoursMinutes}}</li>
                        </ul>
                    </div>
                    <div class="col-auto">
                        <effort-log :propItem="item"></effort-log>
                    </div>
                </div>
            </div>
        </div>



    </div>

</template>

<script>

    import effortLog from './_effort-log'
    import Multiselect from 'vue-multiselect'
    import Tag from 'components/form/input/_tag'
    import { filter, cloneDeep, debounce, clone } from 'lodash'
    import { mapState, mapActions, mapGetters } from 'vuex'
    import UserSelect from 'components/form/input/_user-select'

    export default {
        props: ['item'],
        components: {
            Multiselect,
            UserSelect,
            effortLog,
            Tag
        },

        data: function () {
            return {
                edit: false,
                dirty: false,
                editTags: false,
                dragging: false,
                showUsersList: false,
                saveDebounce: debounce(function () {
                    this.handleUpdateTask()
                }, 5000)
            }
        },

        computed: {
            ...mapState('users', ['users']),
            ...mapState('yodizproject/tags', {tags: 'list'}),
            ...mapGetters('yodizproject/stories', {
                getStoryById: 'getById'
            }),
            ...mapGetters('yodizproject/tasks', {
                getTaskById: 'getById'
            }),
            getFormattedTitle () {
                return this.item.title.replace(/(?:\r\n|\r|\n)/g, '<br>');
            },
            stateTitle: {
                get () {
                    return this.item.title
                },

                set (value) {
                    this.setTaskListProperty({ id: this.item.id, property: 'title', value: value })
                }
            },
            stateTags: {
                get () {
                    return this.item.tags
                },

                set (value) {
                    this.setTaskListProperty({ id: this.item.id, property: 'tags', value })
                }
            },

        },

        methods: {
            ...mapActions('yodizproject/tasks', {
                updateTask: 'updateListObject',
                deleteTask: 'deleteListObject',
                setTaskListProperty: 'setSingleListProperty'
            }),

            ...mapActions('yodizproject/tags', {
                addTag: 'addListObject',
                getTags: 'getList'
            }),

            handleSelectTagCallback (tags) {

                if (tags) {
                    this.stateTags = tags
                } else {
                    this.stateTags = []
                }
        
                this.markDirty()
                this.handleUpdateTask()
            },

            handleAddNewTag(tag) {
                
                console.log('handleAddNewTag', tag)
                let tags = clone(this.stateTags)
                tags.push(tag)
            
                this.stateTags = tags
                this.markDirty()
                this.handleUpdateTask()
            },

            markDirty () {

                this.dirty = true
                //this[SET_SAVE_STATUS](AppConstants.save_status.UNSAVED)

                this.saveDebounce()
            },
            handleUpdateTask () {

                //This stops old debouced saved calls from trigering the save again.
                //For edit to be true, the input blur event hasn't been triggered yet which also performs a save
                if (this.dirty) {
                    return this.updateTask({id: this.item.id, payload: this.item}).then((response) => {
                        this.dirty = false
                        //this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
                    }).catch((response) => {
                        notify.error(response.response.data.errors[Object.keys(response.response.data.errors)[0]])
                     })
                }
            },

            onTitleClick() {
                this.edit = true

                this.$nextTick(() => {
                    this.$refs.stateTitle.focus()
                })
            },

            onTitleBlur() {
                this.edit = false

                this.handleUpdateTask()
            },
            dragStart (i, event) {
                this.dragging = true

                //Set userstory as focus in state
                //Set task as focus in state
                //this.$store.dispatch('yodizproject/stories/setSingle', this.getStoryById(this.item.story_id));
                //this.$store.dispatch('yodizproject/tasks/setSingle', this.getTaskById(this.item.id));

                event.dataTransfer.setData('text/plain', i)
                event.dataTransfer.dropEffect = 'move'
                event.target.style.opacity = .5;
            },

            dragEnd (event) {
                event.target.style.opacity = "";
                this.dragging = false
            },

            getAvatar: function(id) {
        		return process.env.VUE_APP_API_URL + '/user/' + id + '/avatar';
            },

            userChanged(user) {
                return this.updateTask({id: this.item.id, payload: {owner_id: user.id}})
            },

            onDeleteClick() {
                this.$swal(
                    {
                        title: 'Confirm Delete',
                        html: 'Are you sure you want to delete this item #'+this.item.id,
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Delete',
                    }).then( () => {
                        this.deleteTask({id:this.item.id})
                    }, function() {
                });
            },
        }
    }
</script>
